export default __webpack_public_path__ + "static/partner5-7743ae36c9d30a6a39e08f629be2d862.jpg";